// extracted by mini-css-extract-plugin
export default {"host":"MediaBreadCrumb_host__nZRDs"};